const ProfileSettingsPage = () => import('@/components/pages/profile-settings/ProfileSettingsPage')
const TaxonomyManagementPage = () => import ('@/components/pages/taxonomy-management/TaxonomyManagementPage')

export default [
  { path: '/profile-settings', name: 'profileSettingsPage', component: ProfileSettingsPage },
  { path: '/taxonomy-management', name: 'taxonomyManagementPage', component: TaxonomyManagementPage }
]
